import { Model, Factory, belongsTo } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import { randRecentDate, randSentence, randChanceBoolean } from '@ngneat/falso'
import type { MockServer, MirageServer } from './server'
import type { SchemaAttributes } from '../types'
import { pageable, createHtmlParagraph } from './utils.js'
import { safeMathRandom } from '@/utils/number.js'

export type DischargeInstructionVersionData =
  SchemaAttributes<'ConsultationDischargeInstructionVersion'>

export const model = (
  Model as ModelDefinition<DischargeInstructionVersionData>
).extend({
  modifiedUser: belongsTo('user'),
})

export const factory = Factory.extend<DischargeInstructionVersionData>({
  text() {
    return createHtmlParagraph()
  },
  edit_reason() {
    return randChanceBoolean({ chanceTrue: 0.7 })
      ? randSentence({ length: 5 }).join(' ')
      : null
  },
  modified() {
    return randRecentDate().toISOString()
  },
  afterCreate(version, server) {
    // Create a modified user for each version
    const modifiedUser = server.create('user')
    version.update({ modifiedUser })
  },
})

export function routes(server: MockServer) {
  server.get(
    '/discharge_instructions/:parent_lookup_discharge_instruction/versions',
    function (this: MirageServer, schema, request) {
      const dischargeInstructionId =
        request.params.parent_lookup_discharge_instruction

      // Find all versions for this consultation note
      const versions = schema.where('dischargeInstructionVersion', {
        dischargeInstructionId,
      })

      const { data, meta } = pageable(versions, request)

      return {
        ...this.serialize(data),
        meta: {
          pagination: meta,
        },
      }
    },
  )
}

export function seeds(server: MockServer) {
  const dischargeInstructions =
    server.db.consultationDischargeinstructions.slice(0, 10)

  dischargeInstructions.forEach((instruction) => {
    const versionCount = Math.floor(safeMathRandom() * 6) + 2

    for (let i = 0; i < versionCount; i++) {
      server.create('dischargeInstructionVersion', {
        dischargeInstructionId: instruction.id,
        text: i === 0 ? instruction.text : createHtmlParagraph(),
        edit_reason: i === 0 ? null : `Version ${i + 1} edit`,
        modified: new Date(
          Date.now() - (versionCount - i) * 24 * 60 * 60 * 1000,
        ).toISOString(),
      })
    }
  })
}
